/**
 * @file ReportsController.jsx
 * @description Manages report generation and display functionality
 *
 * @section Responsibilities
 * - Handle report generation
 * - Manage report display
 * - Process report data
 * - Handle report filters
 * - Manage report state
 * - Handle report errors
 *
 * @section Dependencies
 * - ReportService: Report generation
 * - DataService: Data processing
 * - FilterService: Filter management
 * - StateManagement: Report state
 *
 * @section Integration Points
 * - Report API: Report generation
 * - Data System: Data processing
 * - Filter System: Report filtering
 * - Export System: Report export
 *
 * @section State Management
 * - reportState: Report status
 * - dataState: Data processing
 * - filterState: Filter status
 * - errorState: Error handling
 *
 * @section Events
 * - onReportGenerate: Report generation
 * - onFilter: Filter application
 * - onExport: Report export
 * - onError: Error handling
 *
 * @section Props
 * @prop {Object} reportConfig - Report configuration
 * @prop {Function} onComplete - Completion callback
 * @prop {Object} initialFilters - Initial filter state
 * @prop {Boolean} autoGenerate - Controls auto-generation
 */

import React, { useState } from "react";
import AdminDashboard from "./modules/admins/AdminDashboard";
import FundManagerDashboard from "./modules/fundManagers/FundManagerDashboard";
import AdvisorDashboard from "./modules/advisors/AdvisorDashboard";
import ClientReports from "./modules/clients/ClientReports";

function ReportsController() {
  var user = JSON.parse(localStorage.session);
  const role = user.role;

  return (
    <>
      {role === "customer" ? (
        <ClientReports />
      ) : role === "admin" ? (
        <AdminDashboard />
      ) : role === "fundManager" ? (
        <FundManagerDashboard />
      ) : (
        <AdvisorDashboard />
      )}
    </>
  );
}

export default ReportsController;
